export const MARQUEE_DEFAULT = ["Proses 1–10 menit", "Gratis biaya admin", "Rate update setiap hari", "Semua bank & eWallet", "Telkomsel · XL · Axis · Three · Indosat · Smartfren"];

const Row = ({ hidden, items }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((t, i) => (
      <span key={`${t}-${i}`} className="flex items-center whitespace-nowrap">
        <span className={`px-8 font-display text-4xl font-semibold tracking-tight md:text-6xl ${i % 2 ? "text-outline" : "text-paper"}`}>{t}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0 text-volt md:h-8 md:w-8"><path fill="currentColor" d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = ({ items }) => {
  const list = Array.isArray(items) && items.length ? items : MARQUEE_DEFAULT;
  return (
    <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/[0.07] py-10">
      <div className="marquee-track flex w-max">
        <Row items={list} />
        <Row items={list} hidden />
      </div>
    </section>
  );
};
